import { FC } from "react";
import { InformationBox, MuiGrid } from "../../../../../components";
import { useSiteCore } from "../../../../../hooks/useSiteCore";
import { CreateGenericAccountHeaderWrapper } from "./CreateGenericAccountHeader.style";
import { createGenericAccounts } from "../../siteCore/SiteCoreKeys";

interface CreateGenericAccountHeaderProps {
  isEdit?: boolean;
}
export const CreateGenericAccountHeader: FC<CreateGenericAccountHeaderProps> = ({
  isEdit: isEditGenericAccount,
}) => {
  const { pageTitle, fetchLabel } = useSiteCore();

  const gridSize = { sm: 6, xs: 12 };
  return (
    <CreateGenericAccountHeaderWrapper>
      <MuiGrid container id="create-client-header-container">
        <MuiGrid
          size={gridSize}
          className="header-left"
          data-testid={"header-left"}
        >
          <InformationBox
            title={
              isEditGenericAccount
                ? fetchLabel(
                    createGenericAccounts.createGenericAccountGenericAccountHeaderTitle,
                    createGenericAccounts.editGenericAccountHeading,
                  )
                : pageTitle
            }
          />
        </MuiGrid>
      </MuiGrid>
    </CreateGenericAccountHeaderWrapper>
  );
};
